import { getApi } from './axiosInstance';

// Fetch all archived images
export const fetchAllImages = async () => {
    try {
        const response = await getApi().get('/Archives');
        return response.data;
    } catch (error) {
        console.error('Error fetching images:', error);
        throw error;
    }
};

// Upload new image
export const uploadImage = async (file, description) => {
    try {
        const formData = new FormData();
        formData.append('image', file);
        if (description) {
            formData.append('description', description);
        }

        const response = await getApi().post('/Archives', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};

// Delete image
export const deleteImage = async (id) => {
    try {
        await getApi().delete(`/Archives/${id}`);
    } catch (error) {
        console.error(`Error deleting image with ID ${id}:`, error);
        throw error;
    }
}; 